/* eslint-disable arrow-body-style */
import React, { useEffect, useState } from 'react';
import './index.scss';
import EditIcon from './component/EditIcon';
import { addAppendix, editAppendix } from '@home/services/studio';
import { useIntl, useParams } from 'umi';
import { notification } from 'tea-component';
import EditModal from './component/EditModal';
import moment from 'moment';

interface IProps {
  className: string;
  style: React.CSSProperties;
  filter: any;
  gameInfo?: any;
  refresh?: any;
  loading: boolean;
  fetchData:()=>void;
  reportData: any;
  // 是否编辑过
  isEdited: boolean;
  editPermission: boolean;
  clickAddAppendix: boolean;
  clickEditAppendix: boolean;
  setClickEditAppendix:()=>void;
  setClickAddAppendix:()=>void;
  appendixContent: string;
}

export default function EditAppendix(props: IProps) {
  const { 
    className, 
    style, 
    filter, 
    gameInfo,
    loading, 
    fetchData, 
    editPermission, 
    clickAddAppendix, 
    clickEditAppendix,
    setClickEditAppendix, 
    setClickAddAppendix, 
    appendixContent,
  } = props || {};
  const { formatMessage } = useIntl();
  const [showModal, setShowModal] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const { studioId } = useParams() || {} as any;
  const { date_type: dateType, start_time: startTime, end_time: endTime } = filter || {};

  // 确认按钮点击事件，编辑gpt 数据
  const handleSubmit = (data: string, id?:number) => {
    let requestFunc;
    let params;
    setSaveLoading(true);
 
    if (id) {
      requestFunc = editAppendix;
      params = {
        id,
        studio_code: studioId,
        unified_id: gameInfo?.edition_unified_id,
        appendix: data || '',
      };
    } else {
      requestFunc = addAppendix;
      params = {
        studio_code: studioId,
        unified_id: gameInfo?.edition_unified_id,
        period: dateType,
        start_date: moment(startTime).format('YYYY-MM-DD'),
        end_date: moment(endTime).format('YYYY-MM-DD'),
        appendix: data || '',
      };
    }
    requestFunc?.(params)
      .then(() => {
        notification.success({
          description: id
            ? formatMessage({ id: 'dbh_studio_funcom_edit_modal_success' })
            : formatMessage({ id: 'dbh_studio_funcom_add_modal_success' }),
          duration: 1000,
        });
        fetchData();
        setShowModal(false);
        setSaveLoading(false);
      })
      .catch(() => {
        notification.error({
          description: id
            ? formatMessage({ id: 'dbh_studio_funcom_edit_modal_failed' })
            : formatMessage({ id: 'dbh_studio_funcom_edit_modal_failed' }),
          duration: 1000,
        });
        setSaveLoading(false);
      });
  };

  const changeShowModal = () => {
    setShowModal(!showModal);
  };

  useEffect(()=>{
    if(clickAddAppendix || clickEditAppendix){
      setShowModal(true);
    }
  },[clickAddAppendix,clickEditAppendix]);

  return (
    <div className={className} style={style}>
      {(!loading && editPermission) && 
      <EditIcon 
        onClick={changeShowModal} 
        showModal={showModal} 
        setClickAddAppendix={setClickAddAppendix}
        clickEditAppendix={clickEditAppendix}/>
      }
      <EditModal
        title={ clickEditAppendix? formatMessage({id: 'dbh_studio_edit_appendix'}) : formatMessage({id: 'dbh_studio_add_appendix'})}
        closeModal={changeShowModal}
        isVisible={showModal}
        data={appendixContent}
        handleSubmit={handleSubmit}
        handleCancel={showModal}
        handelCancel={changeShowModal}
        clickAddAppendix={clickAddAppendix}
        clickEditAppendix={clickEditAppendix}
        setClickAddAppendix={setClickAddAppendix}
        setClickEditAppendix={setClickEditAppendix}
        // 解决重新打开modal编辑器报错问题，editor未实例化
        destroyOnClose={false}
        saveLoading={saveLoading}
      />
    </div>

  );
}
